/* global $, pbFindStoreDynamic */
import('./pb-findstore.css');
import( `../pb-findstore--dynamic/pb-findstore--dynamic.js`).then((module) => module.default());

const pbFindStore = {
    init: () => {
        $(document).ready(function() {
            $("#searchStore").on("submit", function() {
                // Função de retorno de resultados
                $(this)
                    .parent()
                    .addClass("results");
        
                $(this)
                    .parent()
                    .parent()
                    .find("#search-results")
                    .addClass("results");
        
                $(this)
                    .find("#clearSearch")
                    .show();
        
                $(this)
                    .find("#getLocation")
                    .hide();
        
                $(this)
                    .parent()
                    .parent()
                    .find("#search-results")
                    .find("a.jsShowFilters")
                    .on("click", function() {
                        $(this)
                            .parent()
                            .parent()
                            .parent()
                            .removeClass("results");
                        $(this)
                            .parent()
                            .parent()
                            .parent()
                            .addClass("filters");
                        $(this)
                            .parent()
                            .parent()
                            .parent()
                            .find(".content-container")
                            .toggleClass("show");                    
                        return false;
                    });
        
                $(this)
                    .parent()
                    .parent()
                    .find("#search-results")
                    .find("a.jsShowResults")
                    .on("click", function() {
                        $(this)
                            .parent()
                            .parent()
                            .parent()
                            .removeClass("filters");
                        $(this)
                            .parent()
                            .parent()
                            .parent()
                            .addClass("results");
                        return false;
                    });
        
                $(this)
                    .parent()
                    .parent()
                    .find("#search-results")
                    .find("a.jsShowList")
                    .on("click", function() {
                        $(this)
                            .parent()
                            .parent()
                            .parent()
                            .find(".content-container")
                            .toggleClass("show");
                        return false;
                    });
        
                return false;
            });
        });
    }
}

window.loadedComponents.push({ component: 'pb-findstore', init: pbFindStore.init});

export default() => {
    pbFindStore.init();
}